import Times from '~/bootcamp/Activities/components/Times'
import { range } from '~/utils/helpers'

export default function ExpressionNorwegianWithComma({
  multiplier,
  multiplicand,
}: {
  multiplier: string
  multiplicand: string
  maxAnswerLen: number
}): React.ReactElement {
  const multiplierNorweigian = multiplier.split('.').join('')
  const multiPlicandNorweigian = multiplicand.split('.').join('')
  const multiplierCommaIndexOffset = multiplier.indexOf('.') // box width being 8
  const multiplicandCommaIndex = multiplicand.includes('.')
    ? multiplierNorweigian.length + 1 + multiplicand.indexOf('.')
    : -1

  const concatedValuesLength = multiplierNorweigian.length + multiPlicandNorweigian.length + 1

  const commonGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${concatedValuesLength}, minmax(0, 1fr))`,
  }

  return (
    <span
      className="self-end text-center text-md sm:text-lg font-semibold text-purple relative"
      style={commonGridStyle}
    >
      <div className="absolute inset-0 text-left flex items-center justify-evenly pointer-events-none ">
        {range(concatedValuesLength).map((key, index) =>
          key === multiplicandCommaIndex || key === multiplierCommaIndexOffset ? (
            <div className="w-8 sm:w-10 transform -translate-x-1" key={`concatedValuesLength-${key}`}>
              ,
            </div>
          ) : (
            <span className="w-8 sm:w-10 transform -translate-x-1" key={`concatedValuesLength-${index}`} />
          ),
        )}
      </div>
      {range(multiplierNorweigian.length).map((index) => (
        <span className="w-8 sm:w-10" key={`multiplierNorweigian-${index}`}>
          {multiplierNorweigian[index]}
        </span>
      ))}
      <Times />
      {range(multiPlicandNorweigian.length).map((index) => (
        <span className="w-8 sm:w-10" key={`multiplicandNorweigian-${index}`}>
          {multiPlicandNorweigian[index]}
        </span>
      ))}
    </span>
  )
}
